module.exports = __webpack_public_path__ + "static/magician-01-e068ea86d52946fa51be513f0bf7be95.png";